if ('NodeList' in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

var lastScrollTop = 0;

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.gallery-slider__list').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        centerMode: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    centerMode: true,
                    variableWidth: true
                }
            },
            {
                breakpoint: 500,
                settings: {
                centerMode: false,
                variableWidth: false
                }
            }
        ]
    })

    $(window).scroll(function(){
        var scroll_top = $(document).scrollTop();
        if(scroll_top > 0) {
            $('.header__top-section').addClass('down');
        } else {
            $('.header__top-section').removeClass('down');
        }

        if(scroll_top >= ($(document).height() - 150)) {
            $('.header__open-table').addClass('test');
        } else {
            $('.header__open-table').removeClass('test');
        }
    });

    window.onload = function(){
        scrollW();
        window.addEventListener('scroll', function(){
            scrollW();
        })
    }
    function scrollW(){
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if(st > 0){
            if (st > lastScrollTop){
                // downscroll code
                if(!document.getElementById('header').classList.contains('down')){
                    document.getElementById('header').classList.add('down');
                    document.getElementById('header').classList.remove('up');
                }
            } else {
                // upscroll code
                if(!document.getElementById('header').classList.contains('up')){
                    document.getElementById('header').classList.add('up');
                    document.getElementById('header').classList.remove('down');
                }
            }
        } else {
            if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
                document.getElementById('header').classList.remove('up');
                document.getElementById('header').classList.remove('down');
            }
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }

    $('.slider-images').slick({
		arrows:false,
		accessibility:false,
		responsive: [
			{
				breakpoint: 800,
				settings: {
					slidesToShow:2,
                    slidesToScroll: 1
				}
			},
            {
                breakpoint: 600,
                settings: {
                    slidesToShow:1,
                    slidesToScroll: 1
                }
            }
		]
	});

})();